<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-container class="black--text d-flex justify-center" id="title-container">
    <v-card id="top-card-content-area" elevation="2" tile class="title-card">
      <v-card-title
        class="d-flex title-card-text justify-center pa-0"
        style="line-height: 1.15"
      >
        <div class="topbar"></div>
        <div style="width: 100%" class="pa-4 text-left">{{ welcome }}</div>
      </v-card-title>
      <v-card-text>
        <div class="text-h6" v-html="descr_text"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style scoped>
.topbar {
  width: 100%;
  height: 18px;
  background-color: #708e92;
}
.bcs-expansion-content {
  color: black;
}
a_big_blue {
  font-size: 1.1rem;
}
@media (min-width: 768px) {
  #top-card-content-area {
    width: 85%;
    background-color: white;
    height: auto;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_warrant_status",
  props: ["descr_text", "welcome"],
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
